@if (snippet$ | async; as snippet) {
  <div class="mb-4 flex items-center justify-between">
    <h1 class="mat-headline-5 !mb-0">{{ snippet.name }}</h1>

    <div class="flex items-center gap-2">
      @if (snippet.keyword) {
        <pr-content-view
          class="-mb-1.5"
          [content]="getSnippetKeyword(snippet)"
        />
      }

      <button mat-icon-button [matMenuTriggerFor]="snippetMenu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #snippetMenu="matMenu">
        @if (!snippet.deleted) {
          <button mat-menu-item (click)="openSnippetForm(snippet)">
            <mat-icon>edit</mat-icon>
            Edit
          </button>
          <button mat-menu-item (click)="deleteSnippet(snippet)">
            <mat-icon>delete</mat-icon>
            Delete
          </button>
        } @else {
          <button mat-menu-item (click)="undoDelete(snippet)">
            <mat-icon>undo</mat-icon>
            Undo Delete
          </button>
        }
      </mat-menu>
    </div>
  </div>

  @if (snippet.description) {
    <p class="text-slate-600">{{ snippet.description }}</p>
  }

  <pr-content-view [content]="snippet.body" />
}
